<template>
  <div>
    <el-card>
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button type="primary" plain icon="el-icon-plus" @click="showAddmb = true" v-if="admin == 'admin'">
            新增</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-row>
              <el-col :span="12">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>字段说明</span>
                  </div>
                  <el-form label-position="left" inline class="demo-table-expand">
                    <el-form-item :label="key" v-for="(value, key, index) in props.row.template" :key="index"
                      label-width="180px">
                      <span> {{ value }}</span>
                    </el-form-item>
                  </el-form>
                </el-card>
              </el-col>
              <el-col :span="12">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>模板示例</span>
                  </div>
                  <img :src="props.row.imgUrl" alt="">
                </el-card>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column type='index' label="序号" width="60">
        </el-table-column>
        <el-table-column prop="templateName" label="模板名称" width="180">
        </el-table-column>

        <el-table-column prop="addTime" label="创建时间" width="400">
        </el-table-column>
        <el-table-column prop="templateId" label="模板id">
        </el-table-column>

        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="4">
                <el-button size="small" type="primary" @click="TsHand(scope.row)">推送</el-button>
              </el-col>
              <el-col :span="16">
                <el-button size="small" type="primary" @click="hand(scope.row)">修改案例图片</el-button>
              </el-col>
              <el-col :span="4">
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
              </el-col>
            </el-row>
          </template>
        </el-table-column>

      </el-table>

      <el-dialog title="提示" :visible.sync="showTs" width="50%">
        <span>
          <el-form :model="formTS" label-width="80px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="标题">
                  <el-input v-model="formTS.first"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="等级">
                  <el-input v-model="formTS.clmc"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="颜色">
                  <el-input v-model="formTS.ys"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="材料规格">
                  <el-input v-model="formTS.clgg"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="数量">
                  <el-input v-model="formTS.sl"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注">
                  <el-input v-model="formTS.remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="推送人">
                  <el-input v-model="formTS.sender"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客户代码">
                  <el-input v-model="formTS.khdm"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="推送人">
                  <el-input v-model="formTS.templateName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账套id">
                  <el-input v-model="formTS.ztid" :disabled="noAdmin"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="推送类型">
              <el-input v-model="formTS.type"></el-input>
            </el-form-item>
          </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showTs = false">取 消</el-button>
          <el-button type="primary" @click="TsHttp">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 添加模板 -->
      <el-dialog title="添加模板" :visible.sync="showAddmb" width="50%">
        <span>
          <el-form :model="formMb" label-width="80px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="时间">
                  <el-date-picker v-model="formMb.addTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="模板地址">
                  <el-input v-model="formMb.templateUrl"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="模板">
                  <el-input v-model="formMb.template"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="模板ID">
                  <el-input v-model="formMb.templateId"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="数量">
                  <el-input v-model="formMb.sl"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="模板名称">
                  <el-input v-model="formMb.templateName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="添加图片">
                  <el-upload class="avatar-uploader" action="https://srdrjbz.cn:7170/oss/uploadFile"
                    :show-file-list="false" :on-success="handleAvatarSuccess">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" style="width: 40%;height: 40%;">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="quxiao">取 消</el-button>
          <el-button type="primary" @click="xgtp">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>

import mbgg from '../api/mb'
export default {
  name: 'mbgg',
  data() {
    return {
      tableData: [],
      imageUrl: '',
      showTs: false,
      formTS: {},
      TStemplate: "",
      getUrl: "",
      noAdmin: false,
      admin: "",
      formMb: {
        addTime: "",
        id: "",
        imgUrl: "",
        template: "",
        templateId: "",
        templateName: "",
        templateUrl: ""
      },
      showAddmb: false
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      console.log(this.formMb);
      this.imageUrl = res.data;
      this.formMb.imgUrl = this.imageUrl
      console.log(this.formMb);
    },
    async xgtp() {
      console.log(this.formMb)
      let {data:res} = await mbgg.updatemb(this.formMb)
      console.log(res);
      this.$message({
        message: res.msg,
        type: 'success'
      });
      this.formMb = {
        addTime: "",
        id: "",
        imgUrl: "",
        template: "",
        templateId: "",
        templateName: "",
        templateUrl: ""
      }
      this.showAddmb = false
      this.getmb()
    },
    handleDelete(row) {
      this.$confirm('此操作将删除模板' + row.templateName + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await mbgg.delmb(row.id)
        if (res.data.code == 1) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getmb()
        }

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async getmb() {
      let a = 'all'
      let res = await mbgg.getmb(a)
      console.log(res);
      this.tableData = res.data.data
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].template = JSON.parse(this.tableData[i].template)
      }
    },
    hand(row) {
      row.template = JSON.stringify(row.template)
      this.formMb = row
      this.showAddmb = true
    },
    TsHand(info) {
      this.showTs = true
      this.getUrl = info.templateUrl
      // this.TStemplate = info.templateId
      this.formTS = info.template
      if (sessionStorage.getItem("dm") != 'admin') {
        this.formTS.ztid = sessionStorage.getItem("ztid")
        this.noAdmin = true
      }
      this.formTS.templateName = info.templateName
    },
    quxiao(){
      this.formMb = {
        addTime: "",
        id: "",
        imgUrl: "",
        template: "",
        templateId: "",
        templateName: "",
        templateUrl: ""
      }
        this.showAddmb = false
    },
    async TsHttp() {
      mbgg.tSpuda(this.getUrl, this.formTS).then(res => {
        this.$message({
          message: res.data.msg,
          type: "success"
        })
      })
      this.showTs = false
    },
    //
  },
  mounted() {
    this.getmb()
    this.admin = sessionStorage.getItem("dm")
  }
}
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;

  margin-bottom: 0;
  width: 100%;
}

.box-card {
  width: 480px;
  height: 100%;
}
</style>